import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ExternalApplicationOPEEnum} from "./ExternalApplicationOPEEnum";

class O {
  logs?: ApiCallsLogDTO[]
}

/**
 * O Inner Class
 */
class I {
  partitionId!: number;
  applicationId!: number;
  endpoint!: string;
  from!: Date;
  to!: Date;
}

export class ApiCallsLogDTO {
  endpoint!: string;
  timestamp?: Date;
  httpMethod?: string;
  httpStatus?: number;
  responseTimeMs?: number;
}

/**
 * GetExternalApplicationCB class
 */
export class GetExternalApplicationApiCallsLogCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(ExternalApplicationOPEEnum.GetExternalApplicationApiCallsLog);
    this.i = new I();
    this.o = new O();
  }

}
